function displayImage(index, parent){
  var images = document.getElementById(parent).getElementsByTagName("div");
  for(var i = 0; i < images.length; i++) {
    var image = images[i];
    if (image.className != 'pimage')  { continue }
    if(i == index-1) {
      image.style.display="block";
    }
    else {
      image.style.display="none";
    }		
  }	
}


// Hanle mobile menu
var tog = document.getElementById("toggle-main-menu");
var menu = document.getElementById("main-menu");
tog.addEventListener( 'click', toggleMobileMenu, false );

if (window.attachEvent) {
  window.attachEvent('onresize', showDesktopMenu);
} else if (window.addEventListener) {
  window.addEventListener('resize', showDesktopMenu, true);
}

function toggleMobileMenu( e ){
  e.stopPropagation();
  e.preventDefault();
  if (menu.style.display != '' && menu.style.display != 'none')
    menu.style.display = 'none';
  else
    menu.style.display = 'block';
}
function showDesktopMenu(){
  if (!(tog.offsetWidth > 0 || tog.offsetHeight > 0))
    menu.style.display = '';

}